module.exports = __webpack_public_path__ + "img/clark-street-merc.4e443266.jpg";